import React from 'react';
import cn from 'classnames';

import useDomainIncidentRow from 'features/domain/model/useDomainIncidentRow';
import DomainIncidentModal from 'features/domain/ui/DomainIncident/DomainIncidentModal/DomainIncidentModal';
import IncidentStatusBadge from 'shared/ui/Status/IncidentStatusBadge';
import DateWithTodayYesterdayAccent from 'shared/ui/Date/DateWithTodayYesterdayAccent';
import DateWithColorWarnings from 'shared/ui/Date/DateWithColorWarnings/DateWithColorWarnings';
import IncidentStatus from 'shared/ui/Status/IncidentStatus';
import Back from 'shared/ui/icons/General/Back';
import Hide from 'shared/ui/icons/General/Hide';
import IDomainIncident from 'features/domain/model/DomainIncident/IDomainIncident';
import {IDateOptions} from 'shared/lib/datetime';
import {translateDomainIncidentCause} from 'features/domain/lib/domainIncidentHelper';

import styles from './DomainIncidentRow.module.scss';

interface IDomainIncidentRowProps {
    item: IDomainIncident,
    tzString?: string | null,
    hideDomain: boolean,
}

const DomainIncidentRow: React.FC<IDomainIncidentRowProps> = ({item, tzString, hideDomain}) => {
    const {
        isModalOpen,
        closeModal: handleClose,
        expireFormat,
        onRowClick: onTrClick,
        onButtonClick,
        onIgnoreClick: onClickIgnore,
    } = useDomainIncidentRow(item);

    const expireAtOptions: IDateOptions = {format: expireFormat, tzString};

    return (
        <>
            <tr
                className={cn(
                    styles.tr,
                    'clickable',
                    styles.colorIcon,
                )}
                onClick={onTrClick}
            >
                <td>
                    <div className={styles.blockIncidentStatus}>
                        <IncidentStatus resolved={item.resolved}/>
                        <IncidentStatusBadge resolved={item.resolved}/>
                    </div>
                </td>
                {
                    !hideDomain
                    && <td>{item.domainHumanReadable}</td>
                }
                <td>{translateDomainIncidentCause(item.type, item.error_message)}</td>
                <td>
                    <DateWithTodayYesterdayAccent
                        datetime={item.created_at}
                        tzString={tzString}
                    />
                </td>
                <td>
                    {
                        item.expire_at
                            ? <DateWithColorWarnings
                                dateString={item.resolved ? null : item.expire_at}
                                options={expireAtOptions}
                            />
                            : '-'
                    }
                </td>
                <td>
                    <DateWithTodayYesterdayAccent
                        datetime={item.resolved_at}
                        tzString={tzString}
                        isResolvedDate={true}
                    />
                </td>
                <td
                    onClick={onClickIgnore}
                    className={styles.iconHide}
                >
                    <Hide/>
                </td>
                <td onClick={onButtonClick}>
                    <span className={styles.icon}>
                        <Back/>
                    </span>
                </td>
            </tr>

            <DomainIncidentModal
                open={isModalOpen}
                item={item}
                handleClose={handleClose}
                tzString={tzString}
            />
        </>
    );
};

export default DomainIncidentRow;
